import { GameConfig } from '../types';

const BASE_TILE_SIZE = 16;

export function getConfigForLevel(level: number): GameConfig {
  const speedMultiplier = 1 + (level - 1) * 0.05;
  const catSpeedMultiplier = 1 + (level - 1) * 0.04;

  return {
    tileSize: BASE_TILE_SIZE,
    mazeWidthTiles: 28,
    mazeHeightTiles: 31,
    playerSpeed: 80 * speedMultiplier,
    catSpeed: 72 * catSpeedMultiplier,
    scaredCatSpeed: 40,
    scaredDuration: Math.max(3, 8 - (level - 1) * 0.5),
    huntDuration: 20,
    patrolDuration: 7,
  };
}

export const TREAT_THRESHOLDS = [0.7, 0.35];

export function shouldSpawnTreat(cheeseRemaining: number, totalCheese: number): boolean {
  for (const threshold of TREAT_THRESHOLDS) {
    const target = Math.floor(totalCheese * threshold);
    if (cheeseRemaining === target) return true;
  }
  return false;
}
